<template>
    <div id="home" class="backing">
        <v-app>
        <v-container fluid class="container_inner" fill-height>
            <v-row>
                <v-col cols="12">
            <Masthead/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
            <NavBar/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <div style="text-align: left">
                                <p>This is an assortment of known drawings by the late Phoenix-based artist Daniel Field Schmidt. The images were scanned from photos kept in an album by his wife, Barbara Schmidt, and suffer some in quality due to the photo technology of the time. When possible, higher-resolution photos of the actual artwork are included here.</p>

                                <p>Click on any drawing for a larger view of the original work.</p>
                            </div>
                </v-col>
                <v-col cols="12" md="8">
                    <div>
                        <slot />
                    </div>
                </v-col>
            </v-row>

            <v-row justify="center">


            </v-row>
            <FooterBar/>
        </v-container>
        </v-app>
    </div>
</template>

<script>
    import NavBar from '@/components/NavBar'
    import FooterBar from '@/components/FooterBar'
    import Masthead from '@/components/Masthead'

    export default {
        name: 'Drawings',
        data () {
            return {
                alignment: 'center',
                dense: false,
                justify: 'center',
            }
        },
        components: {
            NavBar,
            FooterBar,
            Masthead
        }
    }
</script>

<style scoped>
    .backing {
        background-color: #ccc;
    }
    .cards {
        min-height: 250px;
    }
    .container_inner {
        max-width: 1200px;
        background-color: #fff;
    }
    .danPhoto {
        max-width: 250px;
        height: auto;
        margin-top: 2em;
    }
</style>
